import ActionModel from '../models/ActionModel.js'
import {/*getColoredUseLine,*/ getColoredNameById} from '../../helpers/rollout-message-text-helpers.js'


const NaturalActionModel = {
  ...ActionModel,
  isNatural: true,
  canMiss: false,
  increaseDangerMeterOnUse: 0, //Don't charge DM for naturals
};

export default {
  //Naturals //Caster and Target are the same. For consistency in Naturals, let's always do property changing stuff to the TARGET (affectTargetStatus, affectTargetHpPointsByPercent)
  //-----------------------------------------------------
  "natural_hurt-by-memory-leak": {
    ...NaturalActionModel,
    //Target must be ME. Not using `targetType` here because that implies that the user can "choose" through UI.
    //This one just happens after your action if you have a mem leak.
    affectTargetHpPointsByPercent: -0.11, //11%
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            ` is hurt by the memory leak!`,
          ]
        }
      ]
    },
  },
  "natural_hurt-by-fire": {
    ...NaturalActionModel,
    affectTargetHpPointsByPercent: -0.25, //25
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            `'s laptop is burning in fire!`,
          ]
        }
      ]
    },
  },

  //Lagging
  "natural_lag": {
    ...NaturalActionModel,

    ignoreTargetDieResult: true, //If this move happens while somebody DEAD is targeted (like Revive or Team Revive)
                                  //we'll get the "Person has run out of battery life text...".
                                  //We should never need to see it on a lag out move.

    isNaturalLag: true, //one-off flag needed by `get-rollout`
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            `'s connection is laggy...`,
          ]
        },
        //animation? like a fadey thing
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            `'s move is lost in the lag!`,
          ]
        }
      ]
    },
  },

  "natural_recover-lag": { //The actual "pre" message that recovers the combatant lagging
    ...NaturalActionModel,
    canBeReplaced: false, //Can't be replaced by `submit-action`
    affectTargetStatus: ["lag", "normal"],
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            `'s lagging has ended!`,
          ]
        }
      ]
    },
  },

  "natural_recover-focus": {
    ...NaturalActionModel,
    canBeReplaced: false, //Can't be replaced by `submit-action`
    affectTargetStatus: ["focus", "normal"],
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            `'s Focus has faded!`,
          ]
        }
      ]
    },
  },

  "natural_recover-fury": {
    ...NaturalActionModel,
    canBeReplaced: false, //Can't be replaced by `submit-action`
    affectTargetStatus: ["fury", "normal"],
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            ` has calmed down from Fury.`,
          ]
        }
      ]
    },
  },

  "natural_recover-deadline": {
    ...NaturalActionModel,
    canBeReplaced: false, //Can't be replaced by `submit-action`
    affectTargetStatus: ["deadline", "normal"],
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            `'s deadline has ended!`,
          ]
        }
      ]
    },
  },


  //Escalate a memory-leak to fire
  "natural_memory-leak-to-fire": {
    ...NaturalActionModel,
    canBeReplaced: false, //Can't be replaced by `submit-action`
    affectTargetStatus: ["memory-leak", "fire"],

    //We don't want it to "FAIL" if we don't have a memory leak. We just want it to dissolve.
    //Maybe the same thing is getting an empty array?
    shouldFail: function (actionModel, casterModel, targetModels) {
      if (!targetModels.length) {
        // console.warn('bandaid')
        return true
      }
      return (targetModels[0].status !== "memory-leak");
    },
    getFailStep(actionModel, casterModel, targetModels, descriptionObject) {
      return [
        // {
        //   type: "message",
        //   content: [
        //     `[${casterModel.name}'s naturally escalated from memory-leak to fire but didnt have a memory-leak ]`,
        //   ]
        // }
      ]
    },
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            `'s laptop CAUGHT ON FIRE!`,
          ]
        }
      ]
    },
  },



  //Running out of HP
  "natural_die": {
    ...NaturalActionModel,
    getSuccessStep: function (actionModel, casterModel, targetModels, descriptionObject) {
      return [
        {
          type: "message",
          content: [
            getColoredNameById(casterModel.id),
            ` has run out of battery life!`,
          ]
        }
      ]
    },
  }
}


// WEBPACK FOOTER //
// ./src/battle/battle-data/_naturals.js